import React, { useState, useRef, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calender from '../assets/images/calendar.png';
import { GET_DRIVER_LIST, ADD_VEHICLE_URI } from '../constant';
import { Circles } from 'react-loader-spinner';
import axios from 'axios';
//import Swal from '../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from '../messageBox/customSweetAlert';
import SaveButton from '../components/buttons/SaveButton';
import CancelButton from '../components/buttons/CancelButton';
import { currentDateFormat, restrictSpecialCharacters } from "../utils";
import { useNavigate } from "react-router-dom";
import { vehicleFormValidation } from "../validation/Validation";
import Calender from "../components/Calendar";
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/loaderAction';
import Loader from '../components/loader/Loader';

const Vehicle = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
  let currentInputIndex = 0;
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [endDate, setEndDate] = useState();
  const [startDate, setStartDate] = useState();
  const [insuranceStartDate, setInsuranceStartDate] = useState();
  const [insuranceEndDate, setInsuranceEndDate] = useState();
  const [currentDate, setCurrentDate] = useState(new Date());
  const inputRef = useRef(null);
  const formRef = useRef({});
  const selectRef = useRef('');
  const [myArray, setMyArray] = useState([]);
  const [driverDetails, setDriverDetails] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  //const [loading, setLoading] = useState(false);
  const [vehicleDetails, setvehicleDetails] = useState({
    vehicle_name: '',
    vehicle_make: '',
    vehicle_model: '',
    model_year: '',
    license_plate: '',
    driverIds: [],
    vehicle_number: '',
    vin_number: '',
    vehicle_type: '',
    select_method: '',
    make_method: '',
    seating_capacity: '',
    wheel_capacity: '',
    car_seat_availability: '',
    car_seat_type: '',
    is_certified: '',
    start_date: '',
    end_date: '',
    is_insured: '',
    insurance_start_date: '',
    insurance_end_date: '',
    tie_down_position: '',
    tie_downs: '',
    seat_availability: ''
  });
  const [isInsured, setIsInsured] = useState('0');
  const [isCertified, setIsCertified] = useState('0');

  async function handleFormSubmit(e) {
    e.preventDefault();
    const isValid = vehicleFormValidation(vehicleDetails);
    setErrors(isValid);
    if (Object.keys(isValid).length === 0) {
      try {
        dispatch(setLoading(true));
        const response = await axios.post(ADD_VEHICLE_URI, vehicleDetails);

        console.log(response.data.status);
        if (response.data.status === '200') {
          //console.log('response');
          dispatch(setLoading(false));
          navigate('list');
          Swal.fire({
            title: 'Success!',
            text: response.data.message,
            icon: 'success',
            confirmButtonText: 'OK',
          });
          //console.log(response.data.msg);

        } else {
          dispatch(setLoading(false));
          Swal.fire({
            title: 'Error!',
            text: response.data.message,
            icon: 'Error',
            confirmButtonText: 'OK',
          });
          console.log(response.data.message);
        }
      } catch (error) {
        dispatch(setLoading(false));
        console.error("Error logging in:", error);
      }
    }
  }

  useEffect(() => {
    const loadUser = async () => {
      const response = await axios.get(GET_DRIVER_LIST);
      //console.log(response);
      setDriverDetails(response.data)
    }
    loadUser();
  }, []);

  // const generateInput = (e)=> {
  //   let inputcount = document.getElementsByName('e_name').length+1;
  //   e.preventDefault();
  //   const input = document.createElement('input');
  //   input.type = 'text';
  //   input.setAttribute('data-index',formRef.current.querySelectorAll('.my-3').length);
  //   input.classList.add('form-control', 'my-3');
  //   input.name = 'e_name';
  //   input.setAttribute('autocomplete', 'off');
  //   input.id='driver_' + inputcount;
  //   input.addEventListener('keyup', onChangeHandler);
  //   input.addEventListener('change', handleInputChange);
  //   document.getElementById('inputs-section2').appendChild(input);

  // }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
    setvehicleDetails((prev) => {
      return {
        ...prev,
        [name]: value,
        driverIds: Array.from(formRef.current.querySelectorAll('.my-3')).map((input) => input.value),
      }
    });
    if (name === 'is_insured') {
      setIsInsured(value);
      if (value === '2' || value === '0') {
        setInsuranceStartDate(null);
        setInsuranceEndDate(null);
      }
    }
    if (name === 'is_certified') {
      setIsCertified(value);
      if (value === '2' || value === '0') {
        setStartDate(null);
        setEndDate(null);
      }
    }
  }
  // const handleHiddenInputChange=(e)=>{
  //   console.log(formRef.current.querySelectorAll('.user_id'));
  //   setvehicleDetails((prev)=>{
  //       return{
  //           ...prev,
  //       userId:  Array.from(formRef.current.querySelectorAll('.user_id')).map((input) => input.value  ),
  //      //Ids:  inputRef.current.dataset.code
  //       }
  //   });
  // }
  // const onSuggestHandler = (text,id) => {
  //   //console.log('haiii-',driverDetails);
  //   currentInputIndex= localStorage.getItem('InputIndex') || 0;
  //   const driverDetails=vehicleDetails.driverIds.map((value,index)=>{
  //       if(index == currentInputIndex)
  //           { 
  //            return {text,id};}
  //        else{ return value; }
  //   });

  //   setMyArray((prevData) => {
  //       return [...prevData, id]; // spread the previous array and add the new id
  //     });
  //     setvehicleDetails((prev)=>{
  //       return{
  //        ...prev,
  //        driverIds:  [...driverDetails],
  //       userIds: [...myArray, id]
  //       }

  //   });
  //     //handleHiddenInputChange();
  //   userSuggestionData(driverDetails);
  //   setSuggestions([]);
  // };
  // const userSuggestionData = (passenger)=>{

  //   var inputs = document.querySelectorAll('.my-3');
  //      for (var i = 0; i < inputs.length; i++) {
  //          //inputs[i].value = passenger[i] || '';
  //          if (typeof passenger[i] === 'string') {
  //              inputs[i].value = passenger[i];
  //            } else if (typeof passenger[i] === 'object') {
  //              inputs[i].value = passenger[i].text || '';
  //            } else {
  //              inputs[i].value = '';
  //            }
  //      }
  //  }
  //  const onChangeHandler = (e)=>{
  //   // console.log('Key up event triggered:', e.target);
  //   let text = e.target.value ? e.target.value : "";
  //   let inputIndex = e.target.dataset.index;
  //   localStorage.setItem('InputIndex',inputIndex);
  //   //console.log( e.target);
  //       let matches = [];
  //       if(text.length > 0){
  //           matches = driverDetails.filter(user =>{
  //               const regex = new RegExp(`${text}`,"gi");
  //               return user.first_name.match(regex) || user.user_id.toString().match(regex);
  //           })
  //       }
  //       setSuggestions(matches);
  //      //console.log(matches);
  // }



  return (


    <div className="tab-pane fade active show " id="add-vehicle" role="tabpanel" aria-labelledby="profile-tab">
      <div className="container-fluid px-mobile-2">
        <section>
          <div className='d-flex justify-content-between form-container'>
            <div>
              <h2 className="fs-5 font-weight-600">Add Vehicle</h2>
            </div>

            <div>
              <span >{currentDateFormat(currentDate)}</span>
            </div>
          </div>
        </section>
        <section>
          <div className='bg-white  px-5 py-4'>
            <div>
              <p className="sub-title">Vehicle Information</p>
            </div>
            <form onSubmit={handleFormSubmit} ref={formRef}>
              <div className="form-items">
                <div>
                  <label className='require-field'>Vehicle Name</label>
                  <input type="text" autoComplete='off' className="form-control" id="vehicle_name" name="vehicle_name" onChange={handleInputChange} />
                  {errors.vehicle_name && <span className='errors'>{errors.vehicle_name}</span>}
                </div>
                <div>
                  <label>Vehicle Make</label>
                  <input type="text" autoComplete='off' className="form-control" id="vehicle_make" name="vehicle_make" onChange={handleInputChange} />
                  {errors.vehicle_make && <span className='errors'>{errors.vehicle_make}</span>}
                </div>
                <div>
                  <label>Vehicle Model</label>
                  <input type="text" autoComplete='off' className="form-control" id="vehicle_model" name="vehicle_model" onChange={handleInputChange} />
                  {errors.vehicle_model && <span className='errors'>{errors.vehicle_model}</span>}
                </div>
                <div>
                  <label>Model Year</label>
                  <input type="text" autoComplete='off' className="form-control" id="model_year" name="model_year" onChange={handleInputChange} />
                  {errors.model_year && <span className='errors'>{errors.model_year}</span>}
                </div>
                <div>
                  <label className='require-field'>License Plate #</label>
                  <div>
                    <input
                      type="text"
                      autoComplete='off'
                      className="form-control"
                      id="license_plate"
                      name="license_plate"
                      onChange={handleInputChange}
                      onKeyDown={restrictSpecialCharacters} />
                    {errors.license_plate && <span className='errors'>{errors.license_plate}</span>}
                  </div>
                </div>
                <div className="form-item">
                  <label>STC Vehicle Number</label>
                  <input type="text" autoComplete='off' className="form-control" id="vehicle_number" name="vehicle_number" onChange={handleInputChange} />
                  {errors.vehicle_number && <span className='errors'>{errors.vehicle_number}</span>}
                </div>
                <div className="form-item">
                  <label>VIN Number</label>
                  <input type="text" autoComplete='off' className="form-control" id="vin_number" name="vin_number" onChange={handleInputChange} />
                </div>
                <div>
                  <label>Vehicle Type</label>
                  <div>
                    {/* <select className="form-select" aria-label="Default select example" name="vehicle_type" onChange={handleInputChange}>
                                    <option value="">Select</option>
                                    <option value="1">Van</option>
                                    <option value="2">option 2</option>
                                  </select> */}
                    <input type="text" autoComplete='off' className="form-control" id="vehicle_type" name="vehicle_type" onChange={handleInputChange} />
                  </div>
                  {errors.vehicle_type && <span className='errors'>{errors.vehicle_type}</span>}
                </div>
                <div>
                  <label>Select Method</label>
                  <div>
                    <select className="form-select" aria-label="Default select example" name="select_method" onChange={handleInputChange}>
                      <option value="">Select</option>
                      <option value="1">Lift</option>
                      <option value="2">option 2</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label>Make of Life or Ramp</label>
                  <div>
                    <select className="form-select" aria-label="Default select example" onChange={handleInputChange} name="make_method">
                      <option value="">Select</option>
                      <option value="1">Lift</option>
                      <option value="2">option 2</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label>Seating Capacity</label>
                  <input type="text" autoComplete='off' className="form-control" id="seating-capacity" name="seating_capacity" onChange={handleInputChange} />
                  {errors.seating_capacity && <span className='errors'>{errors.seating_capacity}</span>}
                </div>
                <div>
                  <label>Wheel Chair Capacity</label>
                  <input type="text" autoComplete='off' className="form-control" id="wheel_capacity" name="wheel_capacity" onChange={handleInputChange} />
                  {errors.wheel_capacity && <span className='errors'>{errors.wheel_capacity}</span>}
                </div>
                <div className="form-item-span">
                  <label>Stretcher Availability</label>
                  <div>
                    <select className="form-select" aria-label="Default select example" name="seat_availability" onChange={handleInputChange}>
                      <option value="">Select</option>
                      <option value="1">Yes</option>
                      <option value="2">No</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label>Car Seat Availability</label>
                  <div>
                    <select className="form-select" aria-label="Default select example" name="car_seat_availability" onChange={handleInputChange}>
                      <option value="">Select</option>
                      <option value="1">Yes</option>
                      <option value="2">No</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label>Car Seat Type</label>
                  <div>
                    <select className="form-select" aria-label="Default select example" name="car_seat_type" onChange={handleInputChange}>
                      <option value="">Select</option>
                      <option value="1">Baby Car Seat</option>
                      <option value="2">option 2</option>
                    </select>
                  </div>
                </div>
                <div>
                  <div className="form-item-span">
                    <p className="font-small pb-3 font-weight-600">Is the vehicle MTM certified ?</p>

                    <select className="form-select" aria-label="Default select example" name="is_certified" onChange={handleInputChange}>
                      <option value="0">Select</option>
                      <option value="1">Yes</option>
                      <option value="2">No</option>
                    </select>


                  </div>
                  <div className="error-message">
                    {errors.is_certified && <span className='errors'>{errors.is_certified}</span>}
                  </div>
                </div>
                <div style={{ paddingTop: '26px' }}>
                  <label>Start Date</label>
                  <div className="date-selector align-self-md-end">
                    <Calender
                      selected={startDate}
                      onChange={handleInputChange}
                      setDate={setStartDate}
                      name="start_date"
                      id="start_date"
                      //errors={errors.start_date}
                      disabled={isCertified === '2' || isCertified === '0'}
                    />
                  </div>
                  <div className="error-message">
                    {errors.start_date && <span className='errors'>{errors.start_date}</span>}
                  </div>
                </div>
                <div style={{ paddingTop: '26px' }}>
                  <div className="date-selector align-self-md-end">
                    <label>End Date</label>
                    <Calender
                      selected={endDate}
                      onChange={handleInputChange}
                      setDate={setEndDate}
                      name="end_date"
                      id="end_date"
                      //errors={errors.end_date}
                      disabled={isCertified === '2' || isCertified === '0'}
                    />
                  </div>
                  <div className="error-message">
                    {errors.end_date && <span className='errors'>{errors.end_date}</span>}
                  </div>
                </div>
                <div>
                  <div className="form-item-span">
                    <p className="font-small pb-3 font-weight-600">Is the vehicle Insured?</p>

                    <select className="form-select" aria-label="Default select example" name="is_insured" onChange={handleInputChange}>
                      <option value="0">Select</option>
                      <option value="1">Yes</option>
                      <option value="2">No</option>
                    </select>

                  </div>
                  <div className="error-message">
                    {errors.is_insured && <span className='errors'>{errors.is_insured}</span>}
                  </div>

                </div>
                <div style={{ paddingTop: '26px' }}>
                  <div className="date-selector align-self-md-end">
                    <label>Start Date</label>

                    <Calender
                      selected={insuranceStartDate}
                      onChange={handleInputChange}
                      setDate={setInsuranceStartDate}
                      name="insurance_start_date"
                      id="insurance_start_date"
                      //errors={errors.insurance_start_date}
                      disabled={isInsured === '2' || isInsured === '0'}
                    />
                  </div>
                  <div className="error-message">
                    {errors.insurance_start_date && <span className='errors'>{errors.insurance_start_date}</span>}
                  </div>
                </div>
                <div style={{ paddingTop: '26px' }}>
                  <div className="date-selector align-self-md-end">
                    <label>End Date</label>

                    <Calender
                      selected={insuranceEndDate}
                      onChange={handleInputChange}
                      setDate={setInsuranceEndDate}
                      name="insurance_end_date"
                      id="insurance_end_date"
                      //errors={errors.insurance_end_date}
                      disabled={isInsured === '2' || isInsured === '0'}
                    />
                  </div>
                  <div className="error-message">
                    {errors.insurance_end_date && <span className='errors'>{errors.insurance_end_date}</span>}
                  </div>
                </div>
                <div className="form-item-span">
                  <label>Tie Down Positions</label>
                  <input type="text" autoComplete='off' className="form-control" id="tie_down_position" name="tie_down_position" onChange={handleInputChange} />
                </div>
                <div>
                  <label>Tie Downs</label>
                  <input type="text" autoComplete='off' className="form-control" id="tie_downs" name="tie_downs" onChange={handleInputChange} />
                </div>
              </div>
              {/* <div className="py-3">
                           <p className='sub-title'>Assign Driver</p>
                            <div className="row">
                                <div className="col-lg-3 col-md-4 col-sm-10 pe-0">
                                    <div id="inputs-section2">
                                        <input type="text" data-index='0'  ref={inputRef} autoComplete='off'
                                        className="form-control my-3" value={vehicleDetails.driverIds[0] ? vehicleDetails.driverIds[0].text : ''}  id="e_name" name="e_name" onChange={(e)=>{
                                            handleInputChange(e);
                                        }}  onKeyUp={onChangeHandler} />
                                        {console.log(vehicleDetails.driverIds[0] ? vehicleDetails.driverIds[0] : '')}
                                        <input type="hidden" className='user_id' name="user_ids" onChange={handleHiddenInputChange} value={JSON.stringify(myArray)}/>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-md-2 ">
                                    <p><i className="pi pi-plus-circle assigned-btn" onClick={generateInput} ></i></p>
                                </div>
                                {suggestions &&  suggestions.map((item,index) => (
                                    <div key={index} onClick={()=>onSuggestHandler((item.first_name + " " + (item.middle_name ? item.middle_name : '') + " " + item.last_name + " - " + item.driver?.umpi_no),item.user_id.toString())}> 
                                    <p> {item.first_name + " " + (item.middle_name ? item.middle_name : '') + " " + item.last_name + " - " + item.driver?.umpi_no}</p>
                                    </div>
                                ))}
                            </div>
                            
                        </div> */}
              <div className='footer-content'>
                <SaveButton type='submit' buttonTitle={'ADD VEHICLE'} />

                {/* <CancelButton cancelHandler={() => navigate('list')} /> */}
              </div>
            </form>
          </div>
        </section>
      </div>
      {loading && <Loader />}
    </div>
  );
}
export default Vehicle;